import { CommonModule } from '@angular/common';
import { Component, inject, Inject, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { IonContent, Platform } from '@ionic/angular/standalone';

import { ButtonComponent, SelectComponent, TextareaComponent } from '../../components';
import { ClientUserService, ErrorService, ProUserService } from '../../services';
import { LoadingService } from '../../services/loading/loading.service';
import { ToastService } from '../../services/toast/toast.service';
import { analyticsPageNames } from '../../shared';
import { GlobalsInterface } from '../../types/globals';

@Component({
    selector: 'lib-report',
    standalone: true,
    imports: [IonContent, CommonModule, ReactiveFormsModule, ButtonComponent, SelectComponent, TextareaComponent],
    templateUrl: './report.component.html',
    styleUrl: './report.component.css'
})
export class ReportComponent {
    /* eslint-disable */
    clientUserService = inject(ClientUserService);
    proUserService = inject(ProUserService);

    @Input() title: string = '';
    @Input() submitButtonText: string = 'Send';
    @Input() userType: 'client' | 'pro' = 'client';
    @Input() additionalFormValues: Array<{ field: string; value: string | number }> = []; //Submit additional fields to the form for more context for admins e.g. job_id
    @Input() issueOptions: Array<{ label: string; value: string | number }> = [
        {
            value: "Something isn't working",
            label: "Something isn't working"
        },
        {
            value: 'Report another issue',
            label: 'Report another issue'
        },
        {
            value: 'Give us feedback',
            label: 'Give us feedback'
        }
    ];

    public globals: GlobalsInterface;
    submitAttempt = false;

    reportForm: FormGroup;

    constructor(
        @Inject('globals') globals: GlobalsInterface,
        private fb: FormBuilder,
        private toastService: ToastService,
        private loadService: LoadingService,
        public platform: Platform,
        private errorService: ErrorService
    ) {
        this.globals = globals;
        this.reportForm = this.fb.group({
            what_was_the_issue: ['', Validators.required],
            details_of_report: ['', Validators.required]
        });
    }

    onSubmit() {
        console.log(this.reportForm);
        this.submitAttempt = true;

        const submitObj = {
            form_name: this.userType === 'client' ? 'report an issue' : 'report an issue from guard',
            what_was_the_issue: this.reportForm.value.what_was_the_issue,
            details_of_report: this.reportForm.value.details_of_report,
            ...this.additionalFormValues
        };

        if (this.reportForm.valid) {
            this.loadService.presentLoading();

            if (this.globals.appType === 'client') {
                this.clientUserService.contact(submitObj).subscribe({
                    next: data => this.onContactApiNext(data),
                    error: error => this.onContactApiError(error)
                });
            } else {
                this.proUserService.contact(submitObj).subscribe({
                    next: data => this.onContactApiNext(data),
                    error: error => this.onContactApiError(error)
                });
            }
        } else {
            this.errorService.formErrors(analyticsPageNames.report, this.reportForm);

            this.toastService.errorToast({
                message: 'Please fill out the issue and details of the report',
                duration: 1000
            });
        }
    }

    onContactApiNext(data: any) {
        this.loadService.dismissLoading();
        console.log(data);
        if (data.success === true) {
            this.toastService.successToast({
                message: 'Your message has been sent and will be reviewed',
                duration: 3000
            });
            this.reportForm.reset();
            this.submitAttempt = false;
        } else {
            this.errorService.apiErrors(analyticsPageNames.report, data);

            this.toastService.errorToast({
                message: 'Please try again'
            });
        }
    }

    onContactApiError(error: any) {
        this.loadService.dismissLoading();

        const errorMessage = error.message ? error.message : error.statusText;

        this.errorService.apiErrors(analyticsPageNames.report, errorMessage);

        this.toastService.errorToast({
            message: 'Please try again'
        });
    }
}
